export enum DataType {
  number = 'number',
  string = 'string',
  boolean = 'boolean',
  date = 'date',
  dateTime = 'dateTime',
  longString = 'longString',
  itemRelationship = 'itemRelationship',
  label = 'label',
  link = 'link',
  dataSourceProjects = 'dataSourceProjects',
  enum = 'enum',
  group = 'group'
}
